import { createBrowserHistory } from 'history';
import { getRootUrl } from './urls';
const history = createBrowserHistory({
  basename: getRootUrl()
});
export function getHistory() {
  return history;
}